
const router_modular = [
    {
        path: '/',
        name: 'Home',
        meta: { title: '首页' },
        component: () => import('@/views/HomeView')
    },
    {
        path: '/privacy',
        name: 'Privacy',
        meta: { title: '乐育隐私政策' },
        component: () => import('@/views/PrivacyView')
    },
    {
        path: '/termService',
        name: 'TermService',
        meta: { title: '乐育服务条款' },
        component: () => import('@/views/TermService')
    },
    // 测评报告
    {
        path: '/evalReport/:babyId/:percent',
        name: 'EvalReport',
        meta: { title: '测评报告' },
        component: () => import('@/views/EvalReport')
    },
    // 活动详情
    {
        path: '/activityDetails/:id',
        name: 'ActivityDetails',
        meta: { title: '活动详情' },
        component: () => import('@/views/ActivityDetails')
    },
    // 里程碑
    {
        path: '/babyMilestone/:babyId/:milestoneName/:completeTime',
        name: 'BabyMilestone',
        meta: { title: '宝宝里程碑' },
        component: () => import('@/views/BabyMilestone')
    },
    // pc端home
    {
        path: '/HomePC',
        name: 'HomePC',
        meta: { title: '首页' },
        component: () => import('@/views/HomePC')
    },
    {
        path: '/Evaluation',
        name: 'AiEvaluation',
        meta: { title: 'Ai测评' },
        component: () => import('@/views/AiEvaluation')
    },
]
export default router_modular
